import { capitalize } from 'lodash'

import { PINFLAG_PAYMENT_MESSAGE } from '../../constants/payment'
import {
  BILLING_KEY_TRANSLATION,
  BILLING_KEY_TRANSLATION_STORES
} from '../../constants/translation'
import {
  parseAddressData,
  parseCustomerContact,
  parseShopifyCartData,
  parseWoocomerceCartData,
  parseVtexCartData
} from '../pinflagRequest'
import { getPixelData } from '../pixelUtils'
import { rutWithoutDot } from '../utils'

export const parseOrderWoocommerce = (data) => ({
  cms: 'woocommerce',
  formData: {
    paymentMethod: capitalize(data.gateway),
    paymentMethodTitle:
      PINFLAG_PAYMENT_MESSAGE[data.gateway][data.paymentMethod],
    total: `${data.cart.subtotal}`,
    shippingTotal: `${data.cart.shippingCost}`,
    ...parseCustomerContact(data.customer, 'firstName', 'lastName', false),
    ...parseAddressData(data.address, 'CL-')
  },
  cartData: parseWoocomerceCartData(data.cart),
  isPaid: true
})

export const parseOrderShopify = (data) => ({
  cms: 'shopify',
  formData: {
    paymentMethod: capitalize(data.gateway),
    paymentMethodTitle:
      PINFLAG_PAYMENT_MESSAGE[data.gateway][data.paymentMethod],
    total: `${data.cart.subtotal}`,
    shippingTotal: `${data.cart.shippingCost}`,
    note: data.cartNotes,
    customAttributes: data.customAttributes,
    referenceId: data.referenceId,
    discountCodes: data.discountCodes.map((discount) => discount.code),
    ...parseCustomerContact(data.customer, 'firstName', 'lastName', false),
    ...parseAddressData(data.address, 'CL-')
  },
  cartData: parseShopifyCartData(data.cart, data.selectedServiceType),
  isPaid: true
})

export const parseOrderVtex = (data, vtexOrderFormId) => ({
  cms: 'vtex',
  orderFormId: vtexOrderFormId,
  formData: {
    paymentMethod: capitalize(data.gateway),
    paymentMethodTitle: PINFLAG_PAYMENT_MESSAGE[data.gateway][data.paymentMethod],
    total: `${data.cart.subtotal}`,
    shippingTotal: `${data.cart.shippingCost}`,
    ...parseCustomerContact(data.customer, 'firstName', 'lastName', false),
    ...parseAddressData(data.address, 'CL-')
  },
  cartData: parseVtexCartData(data, vtexOrderFormId),
  isPaid: true
})

const parseUserInformationVtex = (userData) => {
  const firstname = userData.names.substring(0, userData.names.indexOf(' '))
  const lastname = userData.names.substring(userData.names.indexOf(' ') + 1)

  const userInformation = {
    email: userData.email,
    firstName: firstname,
    lastName: lastname,
    documentType: 'rutCHL',
    document: userData.rut,
    phone: userData.phone,
    isCorporate: false
  }
  return userInformation
}

const parseBillingInformationVtex = (billingData) => {
  const billingInformation = {
    corporateDocument: billingData.corporateRut,
    corporateName: billingData.corporateName,
    corporatePhone: billingData.corporatePhone,
    isCorporate: true,
    tradeName: billingData.category,
    stateInscription: billingData.corporatePhone
  }
  return billingInformation
}

export const parseClientProfileVtex = (userData, billingData = null) => {
  const userInformation = parseUserInformationVtex(userData)

  if (billingData) {
    const billingInformation = parseBillingInformationVtex(billingData)
    return { ...userInformation, ...billingInformation }
  }

  return userInformation
}

export const createCustomAttributesForShopify = ({
  siteCookies,
  useTwoClick,
  isSaving,
  extraAttributesShopify,
  billingInfo,
  userInfo,
  companyName
}) => {
  const pixelData = getPixelData(siteCookies)
  return {
    ...(pixelData ? { pixelPinflag: pixelData } : {}),
    userAgreement: useTwoClick > 0 ? isSaving : false,
    ...createBillingInfoAttributes({ billingInfo, userInfo, companyName }),
    ...Object.keys(extraAttributesShopify).reduce((acc, key) => {
      acc[key] = extraAttributesShopify[key]
      return acc
    }, {})
  }
}

export const createBillingInfoAttributes = ({
  billingInfo,
  userInfo,
  companyName
}) => {
  if (billingInfo.corporateName) {
    const bi = Object.keys(billingInfo)
      .filter((key) => billingInfo[key] !== '')
      .map((key) => {
        const newKey = `${
          BILLING_KEY_TRANSLATION_STORES[companyName]
            ? BILLING_KEY_TRANSLATION_STORES[companyName][key]
            : BILLING_KEY_TRANSLATION[key]
        }`
        const newValue =
          companyName === 'Atakama Outdoor' && key === 'corporateRut'
            ? rutWithoutDot(billingInfo[key])
            : billingInfo[key]

        return { [newKey]: newValue }
      })
    return Object.assign({}, ...bi)
  } else {
    // Default parser
    if (companyName === 'Atakama Outdoor') {
      return {
        billing_documento: 39,
        billing_rut: rutWithoutDot(userInfo.rut)
      }
    }
    if (companyName === 'Pronobel') {
      return {
        tipoDocumento: 'Boleta',
        rutEmpresa: rutWithoutDot(userInfo.rut)
      }
    }
    if (companyName === 'Tost') return { 'Tipo de documento': 'boleta', RUT: rutWithoutDot(userInfo.rut) }
    if (companyName === 'Vielco') return { corporateRut: userInfo.rut }
    if (companyName === 'Cosmetic Wholesale') return { tipo_documento: 'BOLETA', rut_cliente: rutWithoutDot(userInfo.rut) }
  }
}
